import { apiUrl, apiOptions, handleError } from './apiUtils';

export const baseUrl = apiUrl + '/images/';

export function getImageById(id: string): Promise<Blob> {
  return fetch(`${baseUrl}${id}`, apiOptions())
    .then(async (res) => {
      if (res.ok) {
        return await res.blob();
      }
      throw new Error('Network response was not ok.');
    })
    .catch(handleError) as Promise<Blob>;
}
